import appointment from 'locales/plus/th/counter/appointment.json'
import doctorSchedule from 'locales/plus/th/counter/doctor-schedule.json'
import patientManagement from 'locales/plus/th/counter/patient-management.json'
import register from 'locales/plus/th/counter/register.json'
import recallLists from 'locales/plus/th/counter/recallLists.json'
import manageDoctorFee from 'locales/plus/th/counter/manage-doctor-fee.json'
import manageDoctorLabFee from 'locales/plus/th/counter/manage-doctor-lab-fee.json'

export const Counter = {
  ...appointment,
  ...doctorSchedule,
  ...patientManagement,
  ...register,
  ...recallLists,
  ...manageDoctorFee,
  ...manageDoctorLabFee
}
